<template>
  <div v-if="currentAppointment && currentAppointment.videoLink" class="vks-float-video" ref="floatVideo">
    <div class="vks-float-video__top">
      <v-icon @mousedown="setState($event, 'resize.start')">
        mdi-arrow-top-left-bottom-right
      </v-icon>
      <v-icon @mousedown="setState($event, 'move.start')">
        mdi-arrow-all
      </v-icon>
      <v-icon class="ms-auto" @click="SET_CURRENT_APPOINTMENT(null)">
        mdi-close
      </v-icon>
    </div>
    <iframe
      class="vks-iframe"
      :src="currentAppointment.videoLink"
      :class="{ 'vks-iframe--locked': listenerAdded }"
      allow="camera; microphone; fullscreen; display-capture; autoplay"
      frameborder="0"
    ></iframe>
    <div class="vks-float-video__bottom">
      <v-icon v-if="currentAppointment.docId" @click="openDocument()">
        mdi-file-document-edit-outline
      </v-icon>
      <v-btn color="white" class="ms-auto" @click="hangup()">
        Завершить конференцию
        <v-icon class="ms-5">
          mdi-phone-hangup
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { CustomerService } from "@/services/api/customer.service";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
export default {
  name: "CoreView",

  components: {},

  computed: {
    ...mapState("appointment", ["currentAppointment"]),
    customerId() {
      return this.$store.state.customer.id;
    },
  },
  data() {
    return {
      startMousePos: [0, 0],
      startVideoPos: [0, 0],
      translateX: 0,
      translateY: 0,
      initSize: [0, 0],
      listenerAdded: false,
      scrollBarWidth: 0,
    };
  },
  mounted() {
    const inner = document.createElement("p");
    inner.style.width = "100%";
    inner.style.height = "200px";

    const outer = document.createElement("div");
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    const w1 = inner.offsetWidth;
    outer.style.overflow = "scroll";
    let w2 = inner.offsetWidth;
    if (w1 === w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    this.scrollBarWidth = w1 - w2;

    document.addEventListener("visibilitychange", this.onvischange);
    document.addEventListener("blur", this.onvischange);
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.onvischange);
    document.removeEventListener("blur", this.onvischange);
  },

  methods: {
    ...mapMutations("appointment", ["SET_CURRENT_APPOINTMENT"]),
    onvischange() {
      const video = this.$refs.floatVideo;
      if (video) {
        this.startVideoPos = [this.translateX, this.translateY];
        this.normalizeWindow();
        document.removeEventListener("mousemove", this.resize);
        document.removeEventListener("mousemove", this.move);
        this.listenerAdded = false;
      }
    },
    async openDocument() {
      try {
        const r = await CustomerService.getDocument(this.customerId, this.currentAppointment.docId);

        await this.$dialog.showAndWait(AddDocument, {
          customerForm: r,
          width: 600,
          doctorId: this.doctorId,
          persistent: true,
          readonly: !!r.doctor_sign,
        });
        this.loading = true;
        await this.$store.dispatch("ikp/loadEvents");
        this.loading = false;
      } catch (e) {
        if (e?.response.status === 404) {
          this.$dialog.notify.error(`Документ №${event.doc_id} не найден`);
        } else {
          this.$dialog.notify.error("Не удалось загрузить документ");
        }
      }
    },
    normalizeWindow() {
      const video = this.$refs.floatVideo;

      video.classList.add("vks-float-video--transition");

      if (video.offsetWidth < 300) {
        video.style.width = "300px";
      }
      if (video.offsetWidth > window.innerWidth - 100) {
        video.style.width = window.innerWidth - 100 + "px";
      }

      if (video.offsetHeight < 200) {
        video.style.height = "200px";
      }
      if (video.offsetHeight > window.innerHeight - 100) {
        video.style.height = window.innerHeight - 100 + "px";
      }
      //   если уехало за правый край
      if (video.offsetLeft + video.offsetWidth > window.innerWidth) {
        video.style.marginRight = 0;
        this.startVideoPos[0] = 0;
        this.translateX = 0;
      }

      //   если уехало за нижний край
      if (video.offsetTop + video.offsetHeight > window.innerHeight) {
        video.style.marginBottom = 0;
        this.startVideoPos[1] = 0;
        this.translateY = 0;
      }

      //   если уехало за левый край
      if (video.offsetLeft < 0) {
        console.log(`tooLeft =>`);
        video.style.marginRight = window.innerWidth - 40 - this.scrollBarWidth - video.offsetWidth + "px";
        this.startVideoPos[0] = this.scrollBarWidth + 40 + video.offsetWidth - window.innerWidth;
        this.translateX = 0;
      }
      //   если уехало за верхний край

      if (video.offsetTop < 0) {
        console.log(`tooTop =>`);
        video.style.marginBottom = window.innerHeight - 40 - video.offsetHeight + "px";
        this.startVideoPos[1] = video.offsetHeight + 40 - window.innerHeight;
        this.translateY = 0;
      }

      setTimeout(() => {
        video.classList.remove("vks-float-video--transition");
      }, 300);
    },
    resize(event) {
      const video = this.$refs.floatVideo;

      video.style.width = this.initSize[0] + this.startMousePos[0] - event.clientX + "px";
      video.style.height = this.initSize[1] + this.startMousePos[1] - event.clientY + "px";

      //   вырубаем слушатель после отпускания кнопки
      if (!this.listenerAdded) {
        document.addEventListener(
          "mouseup",
          () => {
            this.normalizeWindow();
            document.removeEventListener("mousemove", this.resize);
            this.listenerAdded = false;
          },
          { once: true },
        );
        this.listenerAdded = true;
      }
    },
    move(event) {
      const video = this.$refs.floatVideo;
      if (video) {
        const translateX = this.startVideoPos[0] + (event.clientX - this.startMousePos[0]);
        console.log(`this.startVideoPos[0] =>`, this.startVideoPos[0]);
        console.log(`translateX =>`, translateX);

        const translateY = this.startVideoPos[1] + (event.clientY - this.startMousePos[1]);

        video.style.marginRight = translateX * -1 + "px";
        console.log(`video.style.marginRight =>`, video.style.marginRight);

        video.style.marginBottom = translateY * -1 + "px";
        this.translateX = translateX;
        this.translateY = translateY;
        if (!this.listenerAdded) {
          document.addEventListener(
            "mouseup",
            () => {
              console.log(`mouseup =>`);
              this.startVideoPos = [this.translateX, this.translateY];
              this.normalizeWindow();
              document.removeEventListener("mousemove", this.move);
              this.listenerAdded = false;
            },
            { once: true },
          );
          this.listenerAdded = true;
        }
      }
    },
    setState(event, state) {
      const video = this.$refs.floatVideo;
      this.startMousePos = [event.clientX, event.clientY];
      switch (state) {
        case "resize.start":
          this.initSize = [video.offsetWidth, video.offsetHeight];
          document.addEventListener("mousemove", this.resize);
          break;

        case "move.start":
          document.addEventListener("mousemove", this.move);
          break;
        default:
          break;
      }
    },
    async hangup() {
      this.$http(`v1/appointments/${this.currentAppointment.id}/status/finished`);
      this.SET_CURRENT_APPOINTMENT(null);
    },
  },
};
</script>

<style lang="scss">
.vks-float-video {
  background: #000;
  bottom: 20px;
  right: 20px;
  position: fixed;
  width: 640px;
  height: 480px;
  z-index: 200;
  &--transition {
    transition: all 0.3s ease;
  }
  &:hover & {
    &__top,
    &__bottom {
      opacity: 1;
      transform: translateY(0);
    }
  }
  &__top,
  &__bottom {
    color: #fff;
    opacity: 0;
    position: absolute;
    left: 10px;
    right: 10px;
    display: flex;
    gap: 8px;
    transition: all 0.3s ease;
    .v-icon {
      color: currentColor;
    }
  }
  &__top {
    transform: translateY(-5px);
    top: 10px;
  }
  &__bottom {
    bottom: 10px;
    transform: translateY(5px);
  }
  .vks-iframe {
    width: 100%;
    height: 100%;
    &--locked {
      pointer-events: none;
    }
  }
}
</style>
